import { IPhongUuTienBuoi } from "../../model/respone/category/IPhongUuTienBuoi";
import { apiClient } from "../apiClient";

export const PHONG_UU_TIEN_BUOI_API = "phong-uu-tien-buoi";
export const phongUuTienBuoiApi = {
  SelectAll: () => apiClient.get(`${PHONG_UU_TIEN_BUOI_API}`),
  Insert: (payload: IPhongUuTienBuoi) => apiClient.post(`${PHONG_UU_TIEN_BUOI_API}`, payload),
  Update: (payload: IPhongUuTienBuoi) => apiClient.put(`${PHONG_UU_TIEN_BUOI_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${PHONG_UU_TIEN_BUOI_API}/${id}`),
};
